import { useQuery } from "@tanstack/react-query";
import { useFeatureConfig } from "@hooks/useFeatureFlags";
import { COUNTRY_CODE } from "@/constants";
import { CountryCode } from "@/i18n";
import {
  getChubbBillInsuranceOrders,
  getChubbBillInsurances,
} from "./services";

export const useChubbBillInsurancesQuery = () => {
  const { isChubbInsuranceEnabled } = useFeatureConfig();

  return useQuery({
    queryKey: ["insurance", "chubbBillInsurances"],
    queryFn: getChubbBillInsurances,
    enabled: isChubbInsuranceEnabled && COUNTRY_CODE === CountryCode.PL,
  });
};

export const useChubbBillInsuranceOrdersQuery = () => {
  const { isChubbInsuranceEnabled } = useFeatureConfig();

  return useQuery({
    queryKey: ["insurance", "chubbBillInsuranceOrders"],
    queryFn: getChubbBillInsuranceOrders,
    enabled: isChubbInsuranceEnabled && COUNTRY_CODE === CountryCode.PL,
  });
};
